import React from 'react'
import { View } from 'react-native'

export function TwoUp({ children }: { children: React.ReactNode }) {
  return (
    <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 14 }}>
      {React.Children.map(children, child => (
        <View style={{ flex: 1, minWidth: 240 }}>{child}</View>
      ))}
    </View>
  )
}
